// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
export const API_ENDPOINT = 'https://api.ecloudture.com';
export const COGNITO_REGION = 'us-west-2';
export const COGNITO_USER_POOL_ID = 'us-west-2_t6hkzLD2p';
export const COGNITO_USER_POOL_WEB_CLIENT_ID = '5882u253ocm8tr1vdnjqpinmou';
export const COGNITO_DOMAIN = 'elearning.auth.us-west-2.amazoncognito.com';
export const WEBSOCKET_URL = 'wss://websocket.ecloudture.com/notification';
export const BIFROST_URL = 'https://bifrost.ecvhrm.com/login';
